'use strict';

angular.module('clientDashboardApp').directive('pwCheck', [function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
          if(attrs.pwValidate){
            elem.add(elem).on('keyup', function () {
              scope.$apply(function () {
                var v = elem.val().length >= 6;
                ctrl.$setValidity('pwLength', v);
              });
            });
          }
          else{
            var firstPassword = '#' + attrs.pwCheck;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    var v = elem.val()===$(firstPassword).val();
                    var w = elem.val().length > 0;
                    ctrl.$setValidity('pwMatch', v);
                    ctrl.$setValidity('pwLength', w);
                });
            });
          }
        }
    }
}]);
